/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const RESALE_DELETED_BOX = gql`
  mutation ResaleDeletedCostume(
    $filter: UniqBoxFilterInput!
    $data: ResaleCostumeInput!
  ) {
    resaleDeletedCostume(filter: $filter, data: $data) {
      _id
      costumeID
      totalAmount
      amountPaid
      isActive
      paymentStats
      boxStatus

      section {
        _id
        name
      }

      user {
        _id
        email
        firstName
        lastName
        vuid
      }

      payOrder {
        paymentStatus
        totalAmount
        remainingAmount
        amountPaid
      }

      items {
        costumeType {
          name
        }
        costumeFeature {
          name
        }
        costumeAttribute {
          name
        }
        costumeValue {
          name
        }
        isPaid
        paidAmount
        paymentStatus
      }

      createdAt
    }
  }
`;
